
//// 中部导航 固定
// 获取导航栏和 Banner 的元素
const navbar = document.getElementById("hot-deal-navbar");
const banner = document.getElementById("hot-deal-banner-first");

// 获取 Banner 的高度
let bannerHeight = banner != null ? banner.offsetHeight : 0;

// 获取所有菜单项和内容区块
const menuItems = document.querySelectorAll(".navbar-wrap a");
const sections = document.querySelectorAll(".product-display-section");

// 监听滚动事件
window.onscroll = function() {
    let currentSection = "";
    
    if (window.scrollY > bannerHeight) {
        navbar.classList.add("fixed");
    } else {
        navbar.classList.remove("fixed");
    }

    // 检查页面滚动位置，找到在视口中的内容区域
    sections.forEach(section => {
        const sectionTop = section.offsetTop - 70; // 偏移量，确保滚动到中心附近
        if (window.scrollY >= sectionTop) {
            currentSection = section.getAttribute("id");
        }
    });

    // 更新菜单项的活动状态
    menuItems.forEach(menu => {
        menu.classList.remove("active");
        if (menu.getAttribute("href") === "#" + currentSection) {
            menu.classList.add("active");

            const targetMenuItem = menu;
            const menuOffset = targetMenuItem.offsetLeft; // 获取目标菜单项的水平位置
            navbar.scrollTo({
              left: menuOffset-10, // 滚动到该菜单项
              behavior: 'smooth' // 平滑滚动
            });
        }
    });
};

// 获取所有FAQ项
// const faqItems = document.querySelectorAll(".faq-item .faq-title");
// faqItems.forEach(faqTitle => {
//     faqTitle.onclick = function() {
//         var nextElement = faqTitle.nextElementSibling;
//         if(nextElement.classList.contains('active')){
//             nextElement.classList.remove('active');
//             faqTitle.children[0].classList.add('active')
//             faqTitle.children[1].classList.remove('active')
//         }else {
//             nextElement.classList.add('active');
//             faqTitle.children[0].classList.remove('active')
//             faqTitle.children[1].classList.add('active')
//         }
//     };
// });

function productSelectChange(ele) {
    console.log("changed.");
    var selectedOption = ele.options[ele.selectedIndex];
    
    //价格变化
    let optionPrice = selectedOption.getAttribute("data-price");
    let optionOldPrice = selectedOption.getAttribute("data-old-price");
    var priceContent = optionPrice + '<span class="old-price">' + optionOldPrice + '</span>';
    var nextPriceElement = ele.nextElementSibling;
    nextPriceElement.innerHTML = priceContent;

    //差价信息变化        
    // var count_off = parseFloat(optionOldPrice.replace(/[^\d\.]/g,'')) - parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    // count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
    // var countOffStr = optionPrice.charAt(0)+count_off;
    // ele.parentElement.previousElementSibling.previousElementSibling.innerText = countOffStr;
    optionOldPrice = parseFloat(optionOldPrice.replace(/[^\d\.]/g,''));
    optionPrice = parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    if(optionOldPrice>0 && optionOldPrice>optionPrice){
        var percentStr = Math.round(((optionOldPrice-optionPrice)/optionOldPrice)*100) + '%';
        ele.parentElement.previousElementSibling.previousElementSibling.innerText = percentStr;
    }else{
        ele.parentElement.previousElementSibling.previousElementSibling.innerText = '';
    }

    //图片变化
    if(selectedOption.getAttribute("data-image-url") != ""){
        var imgEle = ele.parentElement.previousElementSibling;
        imgEle.setAttribute("src",selectedOption.getAttribute("data-image-url"));
    }

    //选中
    selectedOption.setAttribute("selected",true);

    //添加到购物车按钮的变体ID变化
    let optionId = selectedOption.getAttribute("data-id");
    var hiddenVariantInput = ele.parentElement.nextElementSibling.children[0].children[0];
    hiddenVariantInput.value = optionId;
}

function buyNowProductItem(ele) {
    var productSelectEle = ele.parentElement.previousElementSibling.children[1];
    var selectedOption = productSelectEle.options[productSelectEle.selectedIndex];
    var choosenItemId = selectedOption.getAttribute("data-id");
    window.location.href = '/cart/'+choosenItemId+':1';
}

function productSelectChangeDiff(ele){
    console.log("changed.");
    var selectedOption = ele.options[ele.selectedIndex];
    
    //价格变化
    let optionPrice = selectedOption.getAttribute("data-price");
    let optionOldPrice = selectedOption.getAttribute("data-old-price");
    var priceContent = optionPrice + '<span class="old-price">' + optionOldPrice + '</span>';
    var nextPriceElement = ele.nextElementSibling;
    nextPriceElement.innerHTML = priceContent;

    //差价信息变化   
    optionOldPriceVal = parseFloat(optionOldPrice.replace(/[^\d\.]/g,''));
    optionPriceVal = parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    if(optionOldPriceVal>0 && optionOldPriceVal>optionPriceVal){
        // var percentStr = Math.round(((optionOldPriceVal-optionPriceVal)/optionOldPriceVal)*100) + '%';
        // ele.parentElement.previousElementSibling.previousElementSibling.innerText = percentStr;
        var count_off = optionOldPriceVal - optionPriceVal;
        count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
        var countOffStr = optionPrice.charAt(0)+count_off;
        ele.parentElement.previousElementSibling.previousElementSibling.innerText = countOffStr;
    }else{
        ele.parentElement.previousElementSibling.previousElementSibling.innerText = '';
    }

    //图片变化
    if(selectedOption.getAttribute("data-image-url") != ""){
        var imgEle = ele.parentElement.previousElementSibling;
        imgEle.setAttribute("src",selectedOption.getAttribute("data-image-url"));
    }

    //选中
    selectedOption.setAttribute("selected",true);

    //添加到购物车按钮的变体ID变化
    let optionId = selectedOption.getAttribute("data-id");
    var hiddenVariantInput = ele.parentElement.nextElementSibling.children[0].children[0];
    hiddenVariantInput.value = optionId;
}